export const SPRINT_STATUS_LABELS: Record<number, string> = {
  0: 'Planned',
  1: 'Active',
  2: 'Completed',
  3: 'Cancelled'
};

export interface BacklogIssueDto {
  id: string;
  key: string;
  summary: string;
  type: number;
  typeLabel: string;
  status: number;
  statusLabel: string;
  priority: number;
  priorityLabel: string;
  assigneeId?: string;
  assigneeName?: string;
  epicId?: string;
  epicKey?: string;
  sprintId?: string;
  sprintName?: string;
  storyPoints?: number;
  backlogRank: number;
  createdAt: string;
  dueDate?: string;
  isOverdue?: boolean;
  delayInDays?: number;
  delayLabel?: string;
  remainingLabel?: string;
  deadlineBadge?: string;
}

export interface SprintDto {
  id: string;
  projectId: string;
  projectName: string;
  name: string;
  goal?: string;
  status: number;
  statusLabel: string;
  startDate: string;
  endDate: string;
  startedAt?: string;
  completedAt?: string;
  issueCount: number;
  doneIssueCount: number;
  totalStoryPoints?: number;
  doneStoryPoints?: number;
  capacityPoints?: number;
  capacityHours?: number;
  committedPoints?: number;
  committedStoryPoints?: number;
  committedPointsAtStart?: number;
  committedHours?: number;
  createdAt: string;
  updatedAt?: string;
}

export interface SprintDetailDto extends SprintDto {
  issues: BacklogIssueDto[];
}

export interface SprintBoardColumnDto {
  key: string;
  label: string;
  statuses: number[];
  issues: BacklogIssueDto[];
}

export interface SprintBoardDto {
  sprint: SprintDto;
  columns: SprintBoardColumnDto[];
  backlog: BacklogIssueDto[];
  overdueCount?: number;
  completionPercent?: number;
  sprintDelayDays?: number;
  sprintHealth?: string;
  sprintHealthLabel?: string;
}

export interface CreateSprintRequest {
  projectId: string;
  name: string;
  startDate: string;
  endDate: string;
  goal?: string;
  capacityPoints?: number;
  capacityHours?: number;
}

export interface UpdateSprintRequest {
  name: string;
  startDate: string;
  endDate: string;
  goal?: string;
  capacityPoints?: number;
  capacityHours?: number;
}

export interface SprintRetrospectiveDto {
  id: string;
  sprintId: string;
  whatWentWell?: string;
  whatToImprove?: string;
  actionItems?: string;
  createdAt: string;
  updatedAt?: string;
  createdBy?: string;
}

export interface UpsertSprintRetrospectiveRequest {
  whatWentWell?: string;
  whatToImprove?: string;
  actionItems?: string;
}
